import { MouseEventHandler } from 'react';

import { PrimaryButtonRouterLink } from './PrimaryButtonRouterLink';

type Props = {
  'data-qa-id'?: string;
  onClick?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
  loggedIn: boolean;
  loggedInText?: string;
  loggedOutText?: string;
  hasGradProgram: boolean;
  hasGradProgramText?: string;
};

export function CallToActionButton({
  loggedIn,
  loggedInText = 'Apply',
  loggedOutText = 'Sign Up',
  hasGradProgram,
  hasGradProgramText = 'Edit Grad Program',
  ...props
}: Props) {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-nested-ternary
  const ctaText = hasGradProgram
    ? hasGradProgramText
    : loggedIn
    ? loggedInText
    : loggedOutText;
  return (
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading
    <PrimaryButtonRouterLink to="/manage-grad-program" {...props}>
      {ctaText}
    </PrimaryButtonRouterLink>
  );
}
